import { CloudAnalyticsModel } from "@doitintl/cmp-models";
import { getCollection } from "@doitintl/models-any";
import { useDocumentDataOnce } from "@doitintl/models-hooks";

import { useCachedHook } from "../../../Context/DynamicContext/useCachedHook";

function useNonCachedDataHubMetrics(customerId: string) {
  return useDocumentDataOnce(
    getCollection(CloudAnalyticsModel).doc("metrics").collection("datahubMetrics").doc(customerId)
  );
}

export function useDataHubMetrics(customerId: string) {
  return useCachedHook(useNonCachedDataHubMetrics, {
    key: customerId,
    args: [customerId],
  });
}
